// import React from 'react'
// import "./style.sass";
import Loading from '../casinoLoading/index.jsx';

/* const Loading = ({ loading }) => {
    return (
        loading ? <div className="spinner"></div> : <div></div>
    )
} */

export default Loading;